(function () {
  var layoutLock = false;

  function isDesignMode() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function withLayoutLock(fn) {
    if (layoutLock) return;
    layoutLock = true;
    try {
      fn();
    } finally {
      layoutLock = false;
    }
  }

  function getSection(root) {
    if (root && root.classList && root.classList.contains('shopify-section') && root.classList.contains('idas-collection-grid')) {
      return root;
    }
    if (root && root.querySelector) {
      var nested = root.querySelector('.shopify-section.idas-collection-grid');
      if (nested) return nested;
    }
    return document.querySelector('.shopify-section.idas-collection-grid');
  }

  function bindTabs(section) {
    section.querySelectorAll('[data-idas-collection-tab]').forEach(function (tab) {
      if (tab.getAttribute('data-idas-tab-bound') === 'true') return;
      tab.setAttribute('data-idas-tab-bound', 'true');

      tab.addEventListener('click', function (event) {
        if (tab.getAttribute('data-idas-tab-incomplete') === 'true') {
          event.preventDefault();
          return;
        }
        if (tab.classList.contains('is-active')) {
          event.preventDefault();
        }
      });
    });
  }

  function getGfContainer(section) {
    return section.querySelector('#gf-controls-container') || document.getElementById('gf-controls-container');
  }

  function cleanupLegacyLayout(container, gfActions) {
    if (!container) return;

    var legacyRow = container.querySelector('.idas-gf-selected-row');
    if (legacyRow) {
      var legacyWrapper = legacyRow.querySelector('.globo-selected-items-wrapper:not(.visible-xs)');
      if (legacyWrapper && gfActions && legacyWrapper.parentElement !== gfActions) {
        gfActions.appendChild(legacyWrapper);
      }
      legacyRow.remove();
    }

    var toolbarRow = container.querySelector('.idas-gf-toolbar-row');
    if (toolbarRow) {
      var nestedActions = toolbarRow.querySelector('.gf-actions');
      if (nestedActions && nestedActions.parentElement !== container) {
        container.insertBefore(nestedActions, toolbarRow);
      }
      toolbarRow.remove();
    }
  }

  function findSelectedWrapper(container, gfActions) {
    var wrappers = [];

    if (gfActions) {
      wrappers = wrappers.concat(Array.from(gfActions.querySelectorAll('.globo-selected-items-wrapper:not(.visible-xs)')));
    }
    if (container) {
      container.querySelectorAll('.idas-gf-selected-row .globo-selected-items-wrapper:not(.visible-xs)').forEach(function (node) {
        if (wrappers.indexOf(node) === -1) wrappers.push(node);
      });
    }

    var active = null;
    wrappers.forEach(function (wrapper) {
      if (wrapper.children.length > 0 || (wrapper.textContent && wrapper.textContent.trim().length > 0)) {
        active = wrapper;
      }
    });

    return active || wrappers[wrappers.length - 1] || null;
  }

  function wrapGfControls(gfActions) {
    var container = gfActions.closest('#gf-controls-container');
    cleanupLegacyLayout(container, gfActions);

    var tabs = gfActions.querySelector('.idas-collection-grid__tabs');
    var right = gfActions.querySelector('.idas-gf-actions__right');

    if (!right) {
      right = document.createElement('div');
      right.className = 'idas-gf-actions__right';
      gfActions.appendChild(right);
    }

    Array.from(gfActions.children).forEach(function (child) {
      if (
        child !== tabs &&
        child !== right &&
        !child.classList.contains('globo-selected-items-wrapper')
      ) {
        right.appendChild(child);
      }
    });

    var filterTrigger = right.querySelector('.gf-filter-trigger');
    var filterSelection = right.querySelector('.gf-filter-selection');
    var sortBy = filterSelection && filterSelection.querySelector('.sort-by');

    if (sortBy && sortBy.parentElement !== right) {
      if (filterTrigger && filterTrigger.nextSibling !== sortBy) {
        right.insertBefore(sortBy, filterTrigger.nextSibling);
      } else if (!filterTrigger) {
        right.insertBefore(sortBy, right.firstChild);
      } else {
        right.appendChild(sortBy);
      }
    }

    if (filterSelection && !filterSelection.querySelector('.sort-by') && !filterSelection.textContent.trim()) {
      filterSelection.remove();
    }

    var selectedWrapper = findSelectedWrapper(container, gfActions);
    if (selectedWrapper && selectedWrapper.parentElement !== gfActions) {
      gfActions.appendChild(selectedWrapper);
    }

    if (container) {
      container.querySelectorAll('.globo-selected-items-wrapper:not(.visible-xs)').forEach(function (wrapper) {
        if (wrapper !== selectedWrapper && wrapper.children.length === 0 && !(wrapper.textContent && wrapper.textContent.trim())) {
          wrapper.remove();
        }
      });
    }
  }

  function ensureGfControlsInGrid() {
    var gfGrid = document.getElementById('gf-grid');
    var gfControls = document.getElementById('gf-controls-container');
    if (!gfGrid || !gfControls) return;

    if (gfControls.closest('#gf-grid') === gfGrid) return;

    gfGrid.insertBefore(gfControls, gfGrid.firstChild);
  }

  function tabsFingerprint(tabsEl) {
    if (!tabsEl) return '';

    return Array.from(tabsEl.querySelectorAll('[data-idas-collection-tab]'))
      .map(function (tab) {
        return [
          tab.getAttribute('href') || '',
          tab.getAttribute('data-collection-url') || '',
          tab.getAttribute('data-idas-tab-incomplete') || '',
          (tab.textContent || '').trim()
        ].join('|');
      })
      .join('::');
  }

  function removeTabClone(section) {
    section.querySelectorAll('.idas-collection-grid__tabs[data-idas-tabs-clone="true"]').forEach(function (clone) {
      clone.remove();
    });
  }

  function getGfActions(section) {
    var gfActions = section.querySelector('#gf-controls-container .gf-actions');
    if (gfActions) return gfActions;

    var container = getGfContainer(section);
    if (container) {
      gfActions = container.querySelector('.gf-actions');
      if (gfActions) return gfActions;
    }

    return document.querySelector('#gf-controls-container .gf-actions');
  }

  function resetTabBindings(section) {
    section.querySelectorAll('[data-idas-collection-tab]').forEach(function (tab) {
      tab.removeAttribute('data-idas-tab-bound');
    });
  }

  function syncTabsToGfActions(section) {
    ensureGfControlsInGrid();

    var sourceToolbar = section.querySelector('[data-idas-tabs-source]');
    var sourceTabs = sourceToolbar && sourceToolbar.querySelector('.idas-collection-grid__tabs');
    var gfActions = getGfActions(section);

    if (!sourceTabs || !gfActions) return false;

    var fingerprint = tabsFingerprint(sourceTabs);
    var liveTabs = gfActions.querySelector('.idas-collection-grid__tabs[data-idas-tabs-clone="true"]');

    if (!liveTabs || liveTabs.getAttribute('data-idas-tabs-fingerprint') !== fingerprint) {
      if (liveTabs) liveTabs.remove();

      liveTabs = sourceTabs.cloneNode(true);
      liveTabs.setAttribute('data-idas-tabs-clone', 'true');
      liveTabs.setAttribute('data-idas-tabs-fingerprint', fingerprint);
      gfActions.insertBefore(liveTabs, gfActions.firstChild);
      resetTabBindings(section);
      bindTabs(section);
    }

    wrapGfControls(gfActions);
    section.classList.add('idas-collection-grid--tabs-in-gf');
    return true;
  }

  function fixSwatchImageSrc(section) {
    var filesUrl = window.filesUrl || '/cdn/shop/files/';

    section.querySelectorAll('.idas-product-card .swatch__image').forEach(function (img) {
      var src = img.getAttribute('src') || '';

      if (!src || src.indexOf('/cdn/') !== -1 || src.indexOf('http') === 0 || src.indexOf('data:') === 0) {
        return;
      }

      img.src = filesUrl + src.replace(/^\//, '');
    });
  }

  function syncGridAttributes(section) {
    var wrap = section.querySelector('.idas-collection-grid__products-wrap');
    if (!wrap) return;

    var perRow = wrap.getAttribute('data-products-per-row');
    var mobilePerRow = wrap.getAttribute('data-mobile-products-per-row');
    var mobileLayout = wrap.getAttribute('data-mobile-layout') || 'grid';
    var sourceGrid = wrap.querySelector('.idas-product-grid, .collection-matrix');
    var isSlider = (sourceGrid && sourceGrid.classList.contains('is-mobile-slider')) || mobileLayout === 'slider';

    section.querySelectorAll('#gf-products, .container.collection-matrix.idas-product-grid, .container.collection-matrix').forEach(function (grid) {
      if (perRow) grid.setAttribute('data-products-per-row', perRow);
      if (mobilePerRow) grid.setAttribute('data-mobile-products-per-row', mobilePerRow);
      if (!grid.classList.contains('idas-product-grid')) {
        grid.classList.add('idas-product-grid');
      }
      if (isSlider) {
        grid.classList.add('is-mobile-slider');
        grid.classList.remove('is-mobile-grid');
      } else {
        grid.classList.add('is-mobile-grid');
        grid.classList.remove('is-mobile-slider');
      }
    });
  }

  function scheduleLayout(section) {
    withLayoutLock(function () {
      ensureGfControlsInGrid();

      if (syncTabsToGfActions(section)) return;

      var container = getGfContainer(section);
      if (container) {
        var gfActions = container.querySelector('.gf-actions');
        if (gfActions) wrapGfControls(gfActions);
      }
    });
  }

  function watchProductGrid(section) {
    var grid = section.querySelector('[data-collection-main]');
    if (!grid || grid.getAttribute('data-idas-grid-bound') === 'true') return;

    grid.setAttribute('data-idas-grid-bound', 'true');
    syncGridAttributes(section);
    fixSwatchImageSrc(section);

    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        syncGridAttributes(section);
        fixSwatchImageSrc(section);
      });
    });

    observer.observe(grid, { childList: true, subtree: true });
  }

  function watchGlobo(section) {
    if (section.getAttribute('data-idas-globo-bound') === 'true') return;
    section.setAttribute('data-idas-globo-bound', 'true');

    var pending = false;

    function runLayout() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        scheduleLayout(section);
      });
    }

    if (syncTabsToGfActions(section)) {
      watchGfControls(section);
      return;
    }

    var observer = new MutationObserver(runLayout);
    observer.observe(section, { childList: true, subtree: true });

    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (syncTabsToGfActions(section) || attempts >= 40) {
        clearInterval(timer);
        watchGfControls(section);
      }
    }, 250);
  }

  function watchGfControls(section) {
    var container = getGfContainer(section);
    if (!container) return;

    scheduleLayout(section);

    if (container.getAttribute('data-idas-gf-bound') === 'true') return;
    container.setAttribute('data-idas-gf-bound', 'true');

    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        scheduleLayout(section);
      });
    });

    observer.observe(container, { childList: true, subtree: true, characterData: true });
  }

  function watchSourceTabs(section) {
    var sourceTabs = section.querySelector('[data-idas-tabs-source] .idas-collection-grid__tabs');
    if (!sourceTabs || sourceTabs.getAttribute('data-idas-source-tabs-bound') === 'true') return;

    sourceTabs.setAttribute('data-idas-source-tabs-bound', 'true');

    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        if (isDesignMode()) return;
        syncTabsToGfActions(section);
      });
    });

    observer.observe(sourceTabs, { childList: true, subtree: true, characterData: true });
  }

  function isCollectionProductForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (form.classList.contains('idas-product-card__form')) return true;

    var gridRoot = form.closest('#gf-products, .idas-product-grid, .idas-collection-grid__products-wrap');
    if (!gridRoot) return false;

    var action = form.getAttribute('action') || '';
    return action.indexOf('/cart/add') !== -1;
  }

  function prepareAtcButton(form) {
    var btn = form.querySelector('.idas-product-card__atc, .button--add-to-cart, [name="add"][type="submit"]');
    if (!btn) return null;

    if (!btn.classList.contains('button--add-to-cart')) {
      btn.classList.add('button--add-to-cart');
    }

    if (!btn.getAttribute('data-label')) {
      btn.setAttribute('data-label', (btn.textContent || '').trim() || 'Add to Cart');
    }

    return btn;
  }

  function handleCollectionAtc(form) {
    prepareAtcButton(form);

    var ajaxCart = window.PXUTheme && window.PXUTheme.jsAjaxCart;
    if (ajaxCart && typeof ajaxCart.addToCart === 'function' && window.jQuery) {
      ajaxCart.addToCart(window.jQuery(form));
      return;
    }

    var btn = form.querySelector('.button--add-to-cart, [name="add"][type="submit"]');
    if (btn) {
      btn.setAttribute('disabled', 'disabled');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: new URLSearchParams(new FormData(form)).toString()
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (payload) {
            throw payload;
          });
        }
        return response.json();
      })
      .then(function () {
        if (ajaxCart && typeof ajaxCart.showDrawer === 'function') {
          ajaxCart.showDrawer();
        }
        if (ajaxCart && typeof ajaxCart.updateView === 'function') {
          ajaxCart.updateView();
        }
      })
      .catch(function () {
        /* keep user on collection page even if add fails */
      })
      .finally(function () {
        if (btn) {
          btn.removeAttribute('disabled');
        }
      });
  }

  function bindProductCardAtc() {
    if (window.__idasCollectionAtcBound) return;
    window.__idasCollectionAtcBound = true;

    document.addEventListener(
      'click',
      function (event) {
        var btn = event.target.closest('.idas-product-card__atc, .idas-product-card__form [name="add"][type="submit"]');
        if (!btn || btn.classList.contains('ajax-submit')) return;

        var form = btn.closest('form');
        if (!isCollectionProductForm(form)) return;

        event.preventDefault();
        event.stopPropagation();
        handleCollectionAtc(form);
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!isCollectionProductForm(form)) return;
        if (form.querySelector('.ajax-submit')) return;

        event.preventDefault();
        event.stopPropagation();
        handleCollectionAtc(form);
      },
      true
    );
  }

  function boot(root) {
    bindProductCardAtc();

    var section = getSection(root);
    if (!section) return;

    bindTabs(section);

    if (isDesignMode()) {
      syncTabsToGfActions(section);
      return;
    }

    watchGlobo(section);
    watchProductGrid(section);
    watchSourceTabs(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = getSection(event.target);
    if (section) {
      section.removeAttribute('data-idas-globo-bound');
      var grid = section.querySelector('[data-collection-main]');
      if (grid) grid.removeAttribute('data-idas-grid-bound');
      var container = getGfContainer(section);
      if (container) container.removeAttribute('data-idas-gf-bound');
      var sourceTabs = section.querySelector('[data-idas-tabs-source] .idas-collection-grid__tabs');
      if (sourceTabs) sourceTabs.removeAttribute('data-idas-source-tabs-bound');
      removeTabClone(section);
    }
    boot(event.target);
  });

  document.addEventListener('shopify:block:select', function () {
    var section = getSection(document);
    if (section) syncTabsToGfActions(section);
  });
})();
